<template>
    <div>
        <v-alert type="error" v-if="informText != ''">
            {{ informText }}
        </v-alert>

        <v-col cols="12" style="text-align:right">
            <v-btn color="success" @click="saveData" v-if="rawMaterial.material_thumbnail && (roles.update_material || roles.create_material)">SAVE</v-btn>
            <v-btn color="success" v-else disabled>SAVE</v-btn>
            &nbsp;
            <v-btn color="orange" @click="closeDialog"><span style="color: white;">CANCEL</span></v-btn>
        </v-col>

        <v-col cols="12">
            <v-row>
                <v-col cols="6">
                    <v-text-field
                        label="Material Type"
                        v-model="rawMaterial.material_type"
                        outlined dense
                    ></v-text-field>
                </v-col>
                <v-col cols="6" style="text-align:right">
                    <div>
                        <input
                        type="file"
                        @change="onFileChange"
                        ref="inputPreview"
                        style="display: none"/>

                        <v-btn
                        small
                        color="info"
                        @click="$refs.inputPreview.click()"
                        class="btn btn-sm btn-secondary"
                        v-if="showBtnImg">Select Thumbnail</v-btn>
                        &nbsp;
                        <v-btn
                        small
                        @click="uploadImage"
                        color="success"
                        v-if="imageUpload.length > 0 && showBtnImg && (roles.update_material || roles.create_material)"
                        >Add Thumbnail</v-btn>
                        &nbsp;

                        <v-btn
                        small
                        @click="cancelImageUpload"
                        color="orange"
                        dark
                        style="float:left,margin-bottom:5px;margin-top:5px"
                        v-if="imageUpload.length > 0 && showBtnImg"
                        >Cancel Thumbnail</v-btn>
                        <v-btn
                        small
                        color="orange"
                        v-else
                        disabled
                        >Cancel Thumbnail</v-btn>
                    </div>

                    <v-col cols="12" v-for="(i, index) of imageUpload" :key="index" style="float: right;">
                        <div>Selected Thumbnail:</div>
                        <img :src="i.image" style="width: 120px; margin-left: 5px; margin-top: 5px;float:right"/>
                    </v-col>

                    <v-col cols="12" v-if="rawMaterial.material_thumbnail" style="float: right;">
                        <div><b style="color:red">Added Thumbnail:</b></div>
                        <img :src="rawMaterial.material_thumbnail" style="width: 120px; margin-left: 5px; margin-top: 5px;float:right;"/>
                    </v-col>
                </v-col>

                <v-col cols="12" v-if="rawMaterial.material_thumbnail">
                    
                    <v-btn 
                        style="float: right;margin-bottom: 10px;margin-left: 5px;;" 
                        @click="addVariants"
                        color="teal" outlined>Add Variant</v-btn>
                    <!-- <v-btn 
                        style="float: right;margin-bottom: 10px;" 
                        @click="addOptions"
                        color="indigo" outlined>Add Options</v-btn> -->
                
                    <table width="100%" class="table">
                        <thead>
                            <tr>
                                <th>VariantID</th>
                                <template v-for="(value,key) in rawMaterial.variants[0]" >                                    
                                    <th v-if="key != 'variant_id'" :key="key">{{ key }} 
                                        <!-- <v-btn color="orange" x-small @click="delOptions(key)">
                                            <v-icon color="white" small>mdi-delete</v-icon>
                                        </v-btn> -->
                                    </th>
                                </template>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(i,indexi) in rawMaterial.variants" :key="indexi">
                                <td>{{ i.variant_id }}</td>
                                <template v-for="(value,key) in i" >
                                    <td v-if="key != 'variant_id'" :key="key">
                                        <v-text-field 
                                        type="text" 
                                        dense 
                                        outlined
                                        hide-details 
                                        v-model="i[key]" :label="key"></v-text-field>
                                    </td>
                                </template>
                                <td>
                                    <v-btn x-small color="secondary" @click="copyVariants(indexi)"><v-icon small>mdi-content-copy</v-icon></v-btn>
                                    &nbsp;
                                    <v-btn x-small color="orange" @click="delVariants(indexi)"><v-icon color="white" small>mdi-delete</v-icon></v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <template v-if="rawMaterial.variants.length > 6">
                        <v-btn 
                            style="float: right;margin-left: 5px;" 
                            @click="addVariants"
                            color="teal" outlined>Add Variant</v-btn>
                        <v-btn 
                            style="float: right;" 
                            @click="addOptions"
                            color="indigo" outlined>Add Options</v-btn>
                    </template>
                </v-col>
            </v-row>
        </v-col>
        
        <v-col cols="12" style="text-align:right" v-if="rawMaterial.variants.length > 6">            
            <v-btn color="success" @click="saveData" v-if="rawMaterial.material_thumbnail">SAVE</v-btn>
            <v-btn color="success" v-else disabled>SAVE</v-btn>
            &nbsp;
            <v-btn color="orange" @click="closeDialog"><span style="color: white;">CANCEL</span></v-btn>
        </v-col>
    </div>
</template>

<script>
    import axios from "axios";
    const MAX_IMAGE_SIZE = 6300000;

    export default {
        name:"RawMaterialActionDialog",

        props:{
            selectedItem: String,
            action: String,
            roles: Array,
        },

        data:() => ({
            actionDialog: null,
            selectedItemDialog: null,

            rawMaterial: {
                material_code: null,
                material_thumbnail: null,
                material_type: null,
                variants:[],
            },
            showBtnImg: true,
            imageUpload: [],
            imageUploaded: [],
            
            timeStamp: "",
            informText:"",
        }),

        methods:{
            

            //#region data
            async loadData(){
                var currentSession = await this.$root.$refs.App.currentSession(
                    "rawMaterial-loadData"
                );

                if (currentSession.accessToken) {
                    await axios
                    .get(window.domain + "raw-materials/" + this.selectedItemDialog, {
                        headers: { Authorization: currentSession.accessToken },
                    })
                    .then((response) => {
                        // console.log(this.AuthStr)
                        console.log(response);
                        if(response.data.error_message != ''){
                            this.informText = response.data.error_message
                        }else{
                            this.rawMaterial = response.data.data
                        }
                    })
                    .catch((error) => {
                        console.log("Error:", error);
                        this.loading = false;
                        this.listData = [];
                    });
                } else {
                    console.log("undefined rawMaterial-loadData-undefined: ",currentSession);
                }
            },

            async saveData(){
                var currentSession = await this.$root.$refs.App.currentSession(
                    "rawMaterials-save-sendAPI"
                );

                if (currentSession.accessToken) {
                    if(this.actionDialog == 'Edit'){
                        await fetch(window.domain + "raw-materials/"  + this.selectedItemDialog, {
                        method: "PUT",
                        headers: { Authorization: currentSession.accessToken },
                        body: JSON.stringify(this.rawMaterial),
                        })
                        .then((response) => response.json())
                        .then((data) => {
                            console.log("Create Idea response: ", data);
                            if (data.error_message == "") {
                            this.closeDialog()
                            } else {
                            this.informText = data.error_message;
                            }
                        })
                        .catch((error) => console.log("Err: ", error));
                    }else{
                        await fetch(window.domain + "raw-materials", {
                        method: "POST",
                        headers: { Authorization: currentSession.accessToken },
                        body: JSON.stringify(this.rawMaterial),
                        })
                        .then((response) => response.json())
                        .then((data) => {
                            console.log("Create Idea response: ", data);
                            if (data.error_message == "") {
                            this.closeDialog()
                            } else {
                            this.informText = data.error_message;
                            }
                        })
                        .catch((error) => console.log("Err: ", error));
                    }

                } else {
                    console.log(
                    "currentSession rawMaterial-save-sendAPI-undefined: ",
                    currentSession
                    );
                }
            },
            //#endregion

            //#region add variant

            /*
            addOptions(){
                if(this.rawMaterial.variants.length > 0){
                    let temp = this.rawMaterial.variants[0]
                    let count = 0

                    for(let key in temp){
                        if(key != 'variant_id'){
                            count ++
                        }
                    }

                    this.rawMaterial.variants.map(t => {t['variant_option'+(count+1)] = ""; return t})
                }else{
                    let item = {
                        variant_id: null,
                        variant_option1: "",
                        variant_option2: "",
                        variant_option3: "",
                    }

                    this.rawMaterial.variants.push(item)
                }
                this.$forceUpdate()
            },

            delOptions(key){
                this.rawMaterial.variants.map(t => {delete t[key]; return t})
                console.log('this.rawMaterial.variants: ',this.rawMaterial.variants)
                this.$forceUpdate()
            },
            */

            addVariants(){
                let item = {
                    variant_id: null,
                    variant_option1: "",
                    variant_option2: "",
                    variant_option3: "",
                }

                // Object.assign(item,this.rawMaterial.variants[0])

                // for(let key in item){
                //         item[key] = ""
                //     }else{
                //         item[key] = null
                //     }
                // }

                this.rawMaterial.variants.push(item)
            },

            delVariants(index){
                console.log('index: ',index)
                this.rawMaterial.variants.splice(index,1)
            },

            copyVariants(index){
                let item = JSON.parse(JSON.stringify(this.rawMaterial.variants[index]))

                item.variant_id = null

                this.rawMaterial.variants.push(item)
            },

            //#endregion

            //#region upload image
            onFileChange(e) {
                let files = e.target.files || e.dataTransfer.files;
                if (!files.length) return;

                for(let i of files){
                    this.createImage(i);
                }

                // files.forEach((element) => {
                //     this.createImage(element);
                // });
            },

            createImage(file) {
                this.imageUpload = [];
                this.informText = "";
                let reader = new FileReader();
                reader.onload = (e) => {
                    if (e.target.result.includes("data:image/jpeg")) {
                    this.imageFormat = "image/jpeg";
                    } else if (e.target.result.includes("data:image/png")) {
                    this.imageFormat = "image/png";
                    } else if (e.target.result.includes("data:image/bmp")) {
                    this.imageFormat = "image/bmp";
                    } else {
                    return (this.informText = "Wrong file type - JPG/PNG/BMP only.");
                    }

                    console.log("e.target.result.length: ", e.target.result.length);
                    if (e.target.result.length > MAX_IMAGE_SIZE) {
                    return (this.informText = "Image is loo large - 4.7MB maximum");
                    }

                    var image = {
                    image: e.target.result,
                    format: this.imageFormat,
                    };

                    this.imageUpload.push(image);
                };
                reader.readAsDataURL(file);
            //this.uploadImage()
            },

            async uploadImage() {
                this.showBtnImg = false;
                let axiosArray = [];
                var currentSession = await this.$root.$refs.App.currentSession(
                    "rawMaterial-uploadimageUpload"
                );
                //console.log('currentSession: ',currentSession.accessToken)
                if (currentSession.accessToken) {
                    for (let x = 0; x < this.imageUpload.length; x++) {
                    let postData = {};
                    var base64EncodedStr = this.imageUpload[x].image.split(",")[1];

                    postData["image_base64"] = base64EncodedStr;
                    postData["image_folder"] = "idea-image";
                    postData["image_format"] = this.imageUpload[x].format;
                    postData["product_id"] = this.timeStamp;
                    let newPromise = axios({
                        method: "post",
                        url: window.domain + "products/upload-image",
                        headers: { Authorization: currentSession.accessToken },
                        data: postData,
                    });
                    axiosArray.push(newPromise);
                    }
                } else {
                    console.log(
                    "currentSession rawMaterial-uploadimageUpload: ",
                    currentSession
                    );
                }
                console.log('axiosArray: ',axiosArray)
                let all = await axios.all(axiosArray).catch((error) => {
                    console.log(error);
                    this.informText = error
                });

                console.log('all: ',all)

                this.imageUpload = [];
                this.rawMaterial.material_thumbnail = all[0].data.data.image_url
                this.$refs.inputPreview.value = "";

                this.showBtnImg = true;
            },
            
            cancelImageUpload() {
                this.imageUpload = [];
                this.$refs.inputPreview.value = "";
            },
            //#endregion
                
            closeDialog(){
                this.$root.$refs.rawMaterial.turnOffDialog()
            },
        },

        async mounted(){
            this.actionDialog = JSON.parse(JSON.stringify(this.action))
            this.selectedItemDialog = JSON.parse(JSON.stringify(this.selectedItem))

            this.timeStamp = Date.now().toString() + Math.floor(Math.random() * 10).toString();
            if(this.actionDialog == 'Edit'){
                await this.loadData()
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>